import styled from '@emotion/styled';
import { getOptionValue, snakeToCamelCase } from 'services/helpers';
import { capitalize } from 'components/helpers';
import {
  STEP_NODE_CONFIG,
  STEP_NODE_TYPES,
} from 'pages/AutomationEngine/steps';
import DraggableStepCard from '../../DraggableStepCard';
import * as TypesContent from '../index';
import { getStepIdPreview } from 'pages/AutomationEngine/Engine/utilities';

const Container = styled.span`
  font-size: 1.4em;
  * {
    font-size: 1em;
  }
`;

// t is the first arg in other
const getCardText = ({ step, ...other }) => {
  let key = step.type === 'manual' ? 'ManualTrigger' : step.type;
  // as we don't have separation between Goal and Trigger
  // we need this hack to get correct card name
  if (step.type === STEP_NODE_TYPES.GOAL) {
    key = step.details.type.substr(
      0,
      // +1 need to _ character in `*_goal` card name
      step.details.type.length - (STEP_NODE_TYPES.GOAL.length + 1)
    );
  }

  try {
    const contentFunction =
      TypesContent[`${snakeToCamelCase(capitalize(key))}CardContent`];
    return contentFunction({ step, ...other });
  } catch (error) {
    return 'Unknown';
  }
};

export const getDescription = ({
  step,
  automation,
  fields,
  business,
  groupedOptions,
  t,
}) => {
  const { details } = step;

  const options = getOptions({
    groupedOptions,
    automation,
    fields,
    t,
    business,
  });
  const targetKey = details.stepKey ?? details.triggerKey;
  const data =
    targetKey && options.find((o) => o.value === getOptionValue(targetKey));

  if (!data) {
    return `${t('Go To Step')} ${t('[Deleted]')}`;
  }
  const stepIdPreview = getStepIdPreview(data.value);

  // because the label from UpdateVariableCard is in dangerouslySetInnerHTML, we extract that
  return [
    `${t('Go To')} ${STEP_NODE_CONFIG[data.stepNodeType]?.label(t) ?? data.stepNodeType}: ${
      data.label?.props?.dangerouslySetInnerHTML
        ? data.label?.props?.dangerouslySetInnerHTML.__html
        : data.label
    }`,
    stepIdPreview && `(${stepIdPreview})`,
  ]
    .filter(Boolean)
    .join(' ');
};

export const content = ({ step }) => (
  <Container dangerouslySetInnerHTML={{ __html: step.description }} />
);

const getOptions = ({ groupedOptions, automation, fields, t, business }) => {
  return Object.entries(groupedOptions).reduce((acc, value) => {
    const arr = value[1].map((step) => {
      return {
        stepNodeType: value[0],
        label: getCardText({
          step,
          t,
          automation,
          fields,
          business,
        }),
        value: step.id,
      };
    });
    return [...acc, ...arr];
  }, []);
};

export default function GoToAutomationStep({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
